const React = require("react");
const {lazy, Suspense} = React;
const PropTypes = require("prop-types");
const LoadingCircle = require("../../core/view/LoadingCircle");

const PrimaryRegistrationV2 = lazy(() =>
	import("./PrimaryRegistrationV2").then(m => ({
		default: m.PrimaryRegistrationV2,
	}))
);

const RegistrationFallback = () => (
	<div
		style={{
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			minHeight: "100vh",
		}}
	>
		<LoadingCircle colorType="color" />
	</div>
);

const PagePrimaryRegistration = ({user, studentID}) => {
	return (
		<Suspense fallback={<RegistrationFallback />}>
			<PrimaryRegistrationV2 user={user} studentID={studentID} />
		</Suspense>
	);
};

PagePrimaryRegistration.propTypes = {
	user: PropTypes.object,
	studentID: PropTypes.number,
};

module.exports = PagePrimaryRegistration;
